export default __webpack_public_path__ + "static/media/educatorImg.ff36ae77.png";